import { Route } from 'react-router-dom'
import { observer } from 'mobx-react-lite';
import { SignIn } from 'src/components/User/SignIn';
import { useSystemStore } from 'src/stores';

export const PrivateRoute = observer(({ component: Component, auth: auth, ...rest }) => {
  const { token } = useSystemStore();
  return <Route {...rest} render={props => token ? <Component {...props} /> : <SignIn />} />
});